import { ClientPortfolioPaymentFrequencyEnum } from "web_myplann/Infrastructure/Api/Api";
import type {
	BusinessLoansCreateFormInput,
	BusinessLoansEditFormInput,
} from "web_myplann/Portfolio/Forms/BusinessLoansForm/businessLoansFormSchema";

const BUSINESS_LOANS_FORM_BASE_DEFAULT_VALUES: BusinessLoansEditFormInput = {
	name: "",
	contractNumber: "",
	producer: "",
	product: "",
	signedAt: null,
	startAt: null,
	endAt: null,
};

export const BUSINESS_LOANS_EDIT_FORM_DEFAULT_VALUES: BusinessLoansEditFormInput =
	BUSINESS_LOANS_FORM_BASE_DEFAULT_VALUES;

export const BUSINESS_LOANS_CREATE_FORM_DEFAULT_VALUES: BusinessLoansCreateFormInput =
	{
		...BUSINESS_LOANS_FORM_BASE_DEFAULT_VALUES,
		change: {
			originalObligationAmount: null,
			installment: null,
			interestRate: null,
			fixationEndDate: null,
			paymentFrequency: ClientPortfolioPaymentFrequencyEnum.None,
		},
	};
